<div class="nav-title">
    <h6 class="muted">{{ title }}</h6>
</div>

<div
    kui-list-item
    class="list-item ordered-list-item"
    *ngFor="let telemetry of telemetry | orderedTelemetry: pinned">
    <key-details-ordered-list-item
        [name]="telemetry.name"
        [value]="telemetry.value"
        isPinned="true"
        [isMobile]="isMobile$ | async"
        (unPinned)="onUnPinned($event)"
        (moveUp)="onUp($event, pinned, PINNED_KEY)"
        (moveDown)="onDown($event, pinned, PINNED_KEY)">
    </key-details-ordered-list-item>
</div>

<div
    kui-list-item
    class="list-item ordered-list-item"
    *ngFor="let telemetry of telemetry | orderedTelemetry: ordered">
    <key-details-ordered-list-item
        [name]="telemetry.name"
        [value]="telemetry.value"
        [isMobile]="isMobile$ | async"
        (hidden)="onHidden($event)"
        (pinned)="onPinned($event)"
        (moveUp)="onUp($event, ordered, ORDERED_KEY)"
        (moveDown)="onDown($event, ordered, ORDERED_KEY)">
    </key-details-ordered-list-item>
</div>

<ng-content></ng-content>

<div
    class="list-group-item"
    *ngIf="hidden?.length > 0">
    <h6 class="muted my-2">{{ 'STATUS.DETAILS.SIDEBAR.ACTIONS.HIDDEN' | translate }}</h6>
    <kui-button-group class="flex-wrap">
        <button
            *ngFor="let item of hidden"
            kui-button
            color="dark"
            size="sm"
            outlined="true"
            class="m-1"
            (click)="onShow(item)">
            {{item}}
            <kui-icon
                name="close"
                class="muted ml-1"></kui-icon>
        </button>
    </kui-button-group>
</div>

<div
    kui-list-item
    class="list-item">

    <p kui-list-item-text
        class="mb-0">
    </p>
    <p kui-list-item-text
        class="ml-auto mb-0">
        <a
            (click)="reset()"
            kui-action
            class="ml-auto text-link">Reset Rows</a>
    </p>

</div>